import store from '@/store/store';

export default {
  path: 'analysis',
  name: 'app-analysis',
  component: () => import('@/views/app/analysis/Analysis.vue'),
  meta: {
    pageTitle: 'Analysis'
  },
  beforeEnter: async (to, from, next) => {
    to.meta.pageTitle = 'analysis.header_title';

    const analysisResource = await store.state.router.privateRoot.$request().$get('analysis');
    store.commit('router/updateRouteProp', {
      property: 'analysisResource',
      value: analysisResource
    });
    next();
  },
  props: () => ({
    analysisResource: store.state.router.analysisResource
  })
};
